import Home from '@/views/Home.vue';
import AnalysisSynthesis from '@/components/Map/Analysis/Synthesis';
import AnalysisTransit from '@/components/Map/Analysis/Transit';
import AnalysisImpact from '@/components/Map/Analysis/Impact';
import AnalysisOutlier from '@/components/Map/Analysis/Outlier';
import AnalysisEnvironmental from '@/components/Map/Analysis/Environmental';

const meta = {
  topbar: true,
  exportable: true,
  tutorial: true,
};

export const Routes = [
  {
    path: 'synthesis',
    name: 'synthesis',
    component: AnalysisSynthesis,
    meta,
  },
  {
    path: 'transit',
    name: 'transit',
    component: AnalysisTransit,
    meta,
  },
  {
    path: 'impact',
    name: 'impact',
    component: AnalysisImpact,
    meta,
  },
  {
    path: 'outlier',
    name: 'outlier',
    component: AnalysisOutlier,
    meta,
  },
  {
    path: 'environmental',
    name: 'environmental',
    component: AnalysisEnvironmental,
    meta,
  },
];

export const ResultRoute = {
  path: '/result/:studyId?',
  name: 'result',
  component: Home,
  children: Routes,
  meta,
};
